import { MessageOutlined } from '@ant-design/icons'
import { Button, Card, Flex, Tooltip } from 'antd'
import React, { CSSProperties } from 'react'
import { UIChatItem, UIChatReaction } from '../../types'

type Props = {
  item: UIChatItem
  onReaction: (reaction: UIChatReaction) => void
  onOpenThread?: () => void
}

const STYLE_COMMON: CSSProperties = { width: '32px', height: '32px' }
const AVAILABLE_REACTIONS: UIChatReaction[] = ['👍', '👎']

export const FloatingToolbar: React.FC<Props> = ({
  onReaction,
  onOpenThread,
}) => {
  return <></>
  return (
    <>
      <Flex className="floating-toolbar p-2">
        <Card size="small" styles={{ body: { padding: '4px' } }}>
          <Flex gap={2}>
            {AVAILABLE_REACTIONS.map(reaction => (
              <Flex key={reaction}>
                <Button
                  type="text"
                  onClick={() => onReaction(reaction)}
                  style={STYLE_COMMON}
                >
                  {reaction}
                </Button>
              </Flex>
            ))}

            {onOpenThread && (
              <Tooltip title="Reply in thread">
                <Button
                  type="text"
                  icon={<MessageOutlined />}
                  style={STYLE_COMMON}
                  onClick={onOpenThread}
                />
              </Tooltip>
            )}
          </Flex>
        </Card>
      </Flex>
    </>
  )
}
